import breakpoints from '../constants/breakpoints';

export function isDown(size) {
  return window.matchMedia(`(max-width: ${breakpoints[size] - 0.02}px)`).matches;
}
